import { describeError, reportClientEvent } from './reliability'

type ManagedIntervalOptions = {
  name: string
  intervalMs: number
  run: () => void | Promise<void>
  runImmediately?: boolean
  visibleOnly?: boolean
}

export function startManagedInterval(options: ManagedIntervalOptions): () => void {
  const visibleOnly = options.visibleOnly !== false
  let stopped = false
  let inFlight = false

  const tick = () => {
    if (stopped) return
    if (visibleOnly && document.visibilityState !== 'visible') return
    if (inFlight) return
    inFlight = true
    Promise.resolve(options.run())
      .catch((err) => {
        reportClientEvent('poller_error', { name: options.name, ...describeError(err) }, 'warn')
      })
      .finally(() => { inFlight = false })
  }

  if (options.runImmediately) tick()
  const id = window.setInterval(tick, options.intervalMs)
  const onVisibility = () => {
    if (options.runImmediately && document.visibilityState === 'visible') tick()
  }
  if (visibleOnly) document.addEventListener('visibilitychange', onVisibility)

  return () => {
    stopped = true
    window.clearInterval(id)
    if (visibleOnly) document.removeEventListener('visibilitychange', onVisibility)
  }
}
